module.exports = __webpack_public_path__ + "img/r-152.ab394edc.jpg";